import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthService } from '../auth.service';

/**
 * Guard that protects the multi-step-selection route.
 * Only allows access if there is a pending two-step authentication (CONTRIBUTOR or SUB_CONTRIBUTOR).
 */
@Injectable({
    providedIn: 'root'
})
export class TwoStepPendingAuthGuard implements CanActivate {

    constructor(
        private _authService: AuthService,
        private _router: Router
    ) {}

    canActivate(): boolean | UrlTree {
        // Allow access if there is a pending two-step authentication
        if (this._authService.hasPendingTwoStepAuth) {
            return true;
        }

        // No pending two-step auth, redirect to sign-in
        return this._router.createUrlTree(['/sign-in']);
    }
}
